import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useWidgetContext } from "../context/WidgetContext";
import FeedbackWidget from "./FeedbackWidget";

const FeedbackWidgetWrapper = () => {
  const { isFeedbackWidgetOpen, openWidget, closeWidget } = useWidgetContext();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Hide feedback widget on routes where it would clash with critical flows or sensitive UI.
  const isClumseChatSurface =
    location.pathname === "/chat" || location.pathname.startsWith("/chat/");
  const isTenantChatPage = location.pathname.startsWith("/tenant-chat");
  const isCommunicationPage =
    location.pathname === "/communication" ||
    location.pathname.startsWith("/communication/");
  const isVendorConversationPage =
    location.pathname.startsWith("/conversations/");
  const isPublicListingPage = location.pathname.startsWith("/lease/");
  const isTaxPrepPage = location.pathname === "/tax-prep";
  const isPreflightPage = location.pathname === "/preflight";
  const isCeoPulsePage = location.pathname === "/ceo-pulse";

  // Detect if any modal is open by checking for ant-modal-mask elements
  useEffect(() => {
    const checkModalOpen = () => {
      const modalMasks = document.querySelectorAll(".ant-modal-mask");
      setIsModalOpen(modalMasks.length > 0);
    };

    // Check immediately
    checkModalOpen();

    // Use MutationObserver to watch for modal changes
    const observer = new MutationObserver(checkModalOpen);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    // Also check periodically as a fallback
    const interval = setInterval(checkModalOpen, 100);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  // Show for signed-in and anonymous users on marketing + app surfaces, except excluded routes / modals.
  return (
    !isClumseChatSurface &&
    !isTenantChatPage &&
    !isCommunicationPage &&
    !isVendorConversationPage &&
    !isPublicListingPage &&
    !isTaxPrepPage &&
    !isPreflightPage &&
    !isCeoPulsePage &&
    !isModalOpen
  ) ? (
    <FeedbackWidget
      isVisible={true}
      isOpen={isFeedbackWidgetOpen}
      onToggle={() => {
        if (isFeedbackWidgetOpen) {
          closeWidget("feedback");
        } else {
          openWidget("feedback");
        }
      }}
    />
  ) : null;
};

export default FeedbackWidgetWrapper;
